firebird.service('helperService', [
    '$resource',
    '$location',
    '$q',
    'logService',
    '$rootScope',
    '$window',
    'config',
    'helperStateService',
    'subscriptionService',
    'browserUpgradedService',
    'meetingStateService',
    'browserStateService',
    function (
        $resource,
        $location,
        $q,
        logService,
        $rootScope,
        $window,
        config,
        helperStateService,
        subscriptionService,
        browserUpgradedService,
        meetingStateService,
        browserStateService
    ) {
        const logger = new LogServiceWrapper(logService, 'helperService');
        const redesignPrefix = 'redesign/';

        var self = this;
        var isPageUnloading = false;

        var cachedLocationHost;
        var cachedLocationProtocol;

        this.mobileAppPackageName = '';
        this.mobileHost = undefined;
        this.browserWindowHasFocus = true;
        this.isVideoZoomed = false;
        this.mobileHostLoggedIn = false;
        this.supportsDisplayId = false;
        this.useRedesign = undefined;
        this.minimizedSideBarClickedOpen = null;
        this.sideBarClickedOpen = null;
        this.deviceType = undefined;
        this.isElectronApp = undefined;
        this.isUniteRoomsApp = undefined;
        this.isUniteApp = undefined;
        this.isUniteWebField = undefined;
        this.vdiRef = undefined;

        // cache high frequency helper result.
        this._browserHasWebRTC = undefined;
        this._hasCaptureStream = {};
        this.meetingIsEnding = false;

        this.systemInfo = {
            osRelease: undefined,
            cpuModel: undefined,
            cpuUsage: undefined,
            totalMemory: undefined
        };

        self.uniteSupportedFeatures = {};

        this.rootSubscription = undefined;

        this.refreshStickyEventListeners = function () {
            $window.cordova.removeDocumentEventHandler('sticky-handleopenurl');
            $window.cordova.addStickyDocumentEventHandler('sticky-handleopenurl');
        };

        $rootScope.$on('windowBlur', function (broadcastEvent, browserEvent) {
            self.browserWindowHasFocus = false;
            browserStateService.isFocused = false;
        });

        $rootScope.$on('windowFocus', function (broadcastEvent, browserEvent) {
            self.browserWindowHasFocus = true;
            browserStateService.isFocused = true;
        });

        $rootScope.$on('$destroy', self.onScopeDestroyed);

        this.shouldShowEnvironmentSelectionMenu = function () {
            var hasShowEnvironmentKey = $window.localStorage.getItem('showEnvironmentSelection');
            if (hasShowEnvironmentKey) {
                return true;
            }
            return false;
        };

        this.setMobileHostLoggedIn = function (loggedIn) {
            self.mobileHostLoggedIn = loggedIn;
        };

        this.getMobileHostLoggedIn = function () {
            return self.mobileHostLoggedIn;
        };

        this.isValidMeetingCode = function (meetingCode) {
            const reg = /^\d{9}$/; // Nine digits
            return reg.test(meetingCode);
        };

        this.isValidShortcut = function (str) {
            const isShortcutRegex = /^(?![0-9]*$)[a-z0-9]{4,}$/i;
            return str && isShortcutRegex.test(str);
        };

        this.isAlphanumeric = function (item) {
            const regex = /^[a-z0-9]+$/i;
            return regex.test(item);
        };

        this.setIsRedesign = function (flag) {
            helperStateService.useRedesign = flag;
        };

        this.getIsRedesign = function () {
            return this.useRedesign;
        };

        this.getRedesignPathPrefix = function () {
            return this.getIsRedesign() ? redesignPrefix : '';
        };

        this.getDateFromUTC = function (utc) {
            var fullDate = new Date(utc);

            var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

            var months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];

            var day = days[fullDate.getDay() - 1];
            var date = fullDate.getDate();
            var month = months[fullDate.getMonth()];
            var year = fullDate.getFullYear();

            return day + ', ' + month + ' ' + date + ', ' + year;
        };

        this.getTimeFromUTC = function (utc) {
            var fullDate = new Date(utc);

            var hours = fullDate.getHours();
            var minutes = (fullDate.getMinutes() < 10 ? '0' : '') + fullDate.getMinutes();
            var period = hours >= 12 ? 'PM' : 'AM';

            if (hours > 12) {
                hours = hours - 12;
            }

            return hours + ':' + minutes + ' ' + period;
        };

        this.setMobileMeetingIdentifier = function (id) {
            logger.log('setMobileMeetingIdentifier', 'setting override id ... ' + id);
            this.mobileOverrideId = id;
        };

        this.setMobileLocation = function (loc) {
            logger.log('setMobileLocation', 'called setMobileLocation ' + loc);
            helperStateService.mobileHost = loc;
        };

        this.getEnvironmentCDNUrl = function () {
            var domain = this.getLocationHost();

            if (domain === 'localhost' || domain === 'anymeeting-local.com') {
                domain = 'anymeeting-qa.com';
            }
            return 'fs-cdn.' + domain;
        };

        this.getAccountManagerPassThroughUrl = function (str) {
            return (
                this.getLocationProtocol() +
                '://' +
                this.getLocationHost() +
                '/AccountManager/Login.aspx?ReturnPath=' +
                encodeURIComponent(str)
            );
        };

        this.getAccountManagerRedirectUrl = function (str) {
            return this.getLocationProtocol() + '://' + this.getLocationHost() + '/AccountManager/' + (str || '');
        };

        this.getWebinarDashboardRedirectUrl = function () {
            return this.getLocationProtocol() + '://dashboard.' + this.getLocationHost();
        };

        // extracted browser.helper.ts
        this.getLocationHost = function () {
            return cachedLocationHost;
        };

        this.getLocationProtocol = function () {
            if (window.cordova) {
                return 'https';
            }

            if (!cachedLocationProtocol) {
                var loc = $location.absUrl();
                cachedLocationProtocol = loc.substring(0, loc.indexOf('://'));
            }

            return cachedLocationProtocol;
        };

        this.getForgotPasswordURL = function (meetingAccessCode) {
            var protocol = self.getLocationProtocol().toLowerCase();
            var host = self.getLocationHost().toLowerCase();

            return protocol + '://' + host + '/WebConference/ForgotPassword.aspx?code=' + meetingAccessCode;
        };

        //Returns path of URL, including query parameters
        this.getCurrentPathFromUrl = function (absUrl) {
            var path = absUrl.substring(absUrl.lastIndexOf('/') + 1);
            path = path.split('#')[0];

            return path;
        };

        this.shouldUseMobileRedirect = function () {
            if (this.isMobileRedirectByPass()) {
                return false;
            }

            var deviceShouldUseMobileRedirect = ['iPhone', 'iPad', 'Android'].indexOf(this.getDeviceType()) > -1;
            var isIPadOS = $window.navigator.platform === 'MacIntel' && $window.navigator.maxTouchPoints > 1;

            return deviceShouldUseMobileRedirect || isIPadOS;
        };

        //This function exists to facilitate a specific workaround in our older api integrations
        //unless you're working in that area, use the getMeetingIdentifier function below
        this.getRawMeetingIdentifier = function (absUrl) {
            if (window.cordova) {
                logger.log('getRawMeetingIdentifier', 'override id ' + this.mobileOverrideId);
                return this.mobileOverrideId;
            }

            var path = absUrl.substring(absUrl.lastIndexOf('/') + 1);
            var meetingIdentifier = path.split('#')[0];

            if (meetingIdentifier.indexOf('?') !== -1) {
                meetingIdentifier = meetingIdentifier.substr(0, meetingIdentifier.indexOf('?'));
            }

            return meetingIdentifier;
        };

        this.getMeetingIdentifier = function (absUrl) {
            var unknownMeetingIdentifier = 'unknown';
            if (!absUrl) {
                return unknownMeetingIdentifier;
            }

            //Happy Case Paths:
            //(Non-Mobile) https://meeting.anymeeting[-environment].com/[meeting-code]
            //(Mobile) anymeetingmp://meeting.anymeeting[-environment].com/[meeting-code]

            //With Mobile Universal Links, the absUrl params
            //may sometimes occur without protocol, paths, etc.

            //Stringify param
            absUrl = absUrl + '';

            //Remove protocol, if exists
            var urlWithoutProtocol;
            if (absUrl.indexOf('://') > -1) {
                urlWithoutProtocol = absUrl.split('://')[1];
            } else {
                urlWithoutProtocol = absUrl;
            }

            //Get meeting code / shortcut identifier
            var meetingIdentifier = urlWithoutProtocol.split('/')[1];
            if (!meetingIdentifier) {
                return unknownMeetingIdentifier;
            }

            //Removes '#' and anything after, if exists
            meetingIdentifier = meetingIdentifier.split('#')[0];

            //Remove dashes in meeting code
            meetingIdentifier = meetingIdentifier.replace(/-/g, '');

            //Remove query strings
            if (meetingIdentifier.indexOf('?') !== -1) {
                meetingIdentifier = meetingIdentifier.substr(0, meetingIdentifier.indexOf('?'));
            }

            return meetingIdentifier;
        };

        this.getRecordingId = function (absUrl) {
            var unknownRecordingId = 'unknown';
            if (!absUrl) {
                return unknownRecordingId;
            }

            //Recording URL Path example:
            //https://www.anymeeting-qa.com/111-222-333/ED11DC1234

            //Stringify param
            absUrl = absUrl + '';

            //Remove protocol, if exists
            var urlWithoutProtocol;
            if (absUrl.indexOf('://') > -1) {
                urlWithoutProtocol = absUrl.split('://')[1];
            } else {
                urlWithoutProtocol = absUrl;
            }

            //Get meeting code / shortcut identifier
            var recordingIdentifier = urlWithoutProtocol.split('/')[2];
            if (!recordingIdentifier) {
                return unknownRecordingId;
            }

            //Removes '#' and anything after, if exists
            recordingIdentifier = recordingIdentifier.split('#')[0];

            //Remove query strings
            if (recordingIdentifier.indexOf('?') !== -1) {
                recordingIdentifier = recordingIdentifier.substr(0, recordingIdentifier.indexOf('?'));
            }

            return recordingIdentifier;
        };

        this.getHostNameFromUrl = function (url) {
            var unknownLocation = 'unknown';
            if (!url) {
                return unknownLocation;
            }

            //Stringify param
            url = url + '';

            //Remove protocol, if exists
            var urlWithoutProtocol;
            if (url.indexOf('://') > -1) {
                urlWithoutProtocol = url.split('://')[1];
            } else {
                urlWithoutProtocol = url;
            }

            //Get hostname
            var hostName = urlWithoutProtocol.split('/')[0];

            return hostName || unknownLocation;
        };

        // extracted browser.helper.ts
        this.getQueryParameter = function (name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(location.search);

            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };

        this.setQueryParameter = function (uri, name, value) {
            const pattern = new RegExp('([?&])' + name + '=.*?(&|$)', 'i');
            const separator = uri.indexOf('?') !== -1 ? '&' : '?';
            const match = uri.match(pattern);

            if (match) {
                let previousValue = match[0].substring(match[0].indexOf('=') + 1);
                return previousValue === value ? uri : uri.replace(pattern, '$1' + name + '=' + value + '$2');
            }

            return uri + separator + name + '=' + value;
        };

        // extracted browser.helper.ts
        this.browserHasWebRTC = function () {
            return this._browserHasWebRTC;
        };

        // whether <video> and/or <canvas> has captureStream or not. if element is supplied as one of
        // "video" or "canvas", check for that, else check for both.
        this.hasCaptureStream = function (element) {
            if (element == 'video' || element == 'canvas') {
                if (this._hasCaptureStream[element] === undefined) {
                    const value = !!$window.$(element == 'video' ? '<video/>' : '<canvas/>')[0].captureStream;
                    this._hasCaptureStream[element] = value;
                }
                return this._hasCaptureStream[element];
            } else {
                return this.hasCaptureStream('video') && this.hasCaptureStream('canvas');
            }
        };

        this.isBrowserSupported = function () {
            var deviceType = this.getDeviceType();

            //Allow Android/iOS browsers so we can redirect to mobile apps

            if (deviceType === null) {
                // regular browsers
                return true;
            } else if (deviceType === 'Android') {
                return true;
            } else if (deviceType === 'iPhone' || deviceType === 'iPad') {
                return true;
            } else {
                return false;
            }
        };

        this.isIosDevice = function () {
            var deviceType = this.getDeviceType();
            if (
                deviceType === 'iPhone' ||
                deviceType === 'iPad' ||
                ($window.navigator.userAgent.indexOf('Macintosh') > -1 && navigator.maxTouchPoints > 1) // ipad have the same useragent as mac
            ) {
                return true;
            } else {
                return false;
            }
        };

        this.isBrowserInFocus = function () {
            return this.browserWindowHasFocus;
        };

        this.getResellerIdFromConfig = function (resellerType) {
            var keys = config.resellerId;
            var locationHost = this.getLocationHost().toLowerCase();

            if (locationHost === 'localhost' || locationHost.indexOf('-local.com') !== -1) {
                return keys.qa[resellerType];
            } else if (locationHost.indexOf('-qa.com') !== -1) {
                return keys.qa[resellerType];
            } else if (locationHost.indexOf('-staging.com') !== -1) {
                return keys.staging[resellerType];
            }

            return keys.prod[resellerType];
        };

        // extracted browser.helper.ts
        this.isWindows = function () {
            return $window.navigator.platform.indexOf('Win') > -1;
        };

        // extracted browser.helper.ts
        this.isMac = function () {
            return $window.navigator.platform.indexOf('Mac') > -1;
        };

        this.isChromeOS = function () {
            var regex = /(CrOS)/;
            return regex.test($window.navigator.userAgent);
        };

        this.isLinux = function () {
            return $window.navigator.platform.indexOf('Linux') > -1;
        };

        this.isElectronSupportedPlatform = function () {
            return (this.isMac() || this.isWindows()) && !this.shouldUseMobileRedirect();
        };

        //Camaro = Electron App
        this.shouldUseCamaro = function () {
            return this.isElectronSupportedPlatform() && !this.isElectron();
        };

        //really a temporary config function and can be turned off after full release
        this.isClientElectronDetectionEnabled = function () {
            if (!config || !config.clientElectronDetect) {
                return false;
            }

            if (this.getLocationHost() === 'localhost') {
                return config.clientElectronDetect.qa;
            }

            if (this.getLocationHost().indexOf('-qa.com') !== -1) {
                return config.clientElectronDetect.qa;
            }

            if (this.getLocationHost().indexOf('-staging.com') !== -1) {
                return config.clientElectronDetect.staging;
            }

            return config.clientElectronDetect.prod;
        };

        this.isCamaro = function () {
            return ($window.navigator.userAgent.match(/Electron/g) || []).length === 2;
        };

        this.isCamaroVulnerabilityFixed = function (resellerCode) {
            if (!config || !config.camaroVulnerabilityFixed) {
                return false;
            }
            const env = this.getEnvironment();
            const resellerConfig = config.camaroVulnerabilityFixed[resellerCode];
            return (resellerConfig && resellerConfig[env]) || false;
        };

        this.isUniteWithoutAuthReleased = function (resellerCode) {
            if (!config || !config.uniteWithoutAuthReleased) {
                return false;
            }
            const env = this.getEnvironment();
            const resellerConfig = config.uniteWithoutAuthReleased[resellerCode];
            return (resellerConfig && resellerConfig[env]) || false;
        };

        this.hasScreenShareOS = function () {
            if (this.isWindows() || this.isMac() || this.isChromeOS() || this.isLinux()) {
                return true;
            } else {
                return false;
            }
        };

        this.hasScreenShareBrowser = function () {
            // crossbrowser compatibility check.
            if (this.isChrome() || this.isFirefox() || this.isSafari() || this.isEdgeBrowser() || this.isElectron()) {
                return true;
            } else {
                return false;
            }
        };

        this.getMediaDevices = function () {
            return navigator.mediaDevices;
        };

        this.getUserMedia = function () {
            return navigator.getUserMedia;
        };

        this.mobileAlert = function (message, title, callback) {
            //Syntax: alert([message], [callback], [title], [buttonName]);
            $window.navigator.notification.alert(message, callback, title, 'OK');
        };

        this.mobileConfirm = function (message, title, callback, customBtnNames) {
            var btnNames = customBtnNames || 'OK,Cancel';

            //Syntax: alert([message], [callback], [title], [buttonName]);
            $window.navigator.notification.confirm(message, callback, title, btnNames);
        };

        this.mobilePrompt = function (message, promptCallback, title, buttonLabels, defaultText) {
            //Syntax: prompt(message, promptCallback, [title], [buttonLabels], [defaultText]);
            $window.navigator.notification.prompt(
                message, // message
                promptCallback, // callback to invoke
                title, // title
                buttonLabels, // buttonLabels
                defaultText // defaultText
            );
        };

        this.delayedWebRTCRefresh = function () {
            if (window.cordova && window.device.platform === 'iOS') {
                setTimeout(function () {
                    cordova.plugins.iosrtc.refreshVideos();
                }, 100);
            }
        };

        this.getDeviceType = function () {
            if (this.deviceType === undefined) {
                var userAgent = $window.navigator.userAgent;
                this.deviceType =
                    userAgent.match(/iPad/i) == 'iPad'
                        ? 'iPad'
                        : userAgent.match(/iPhone/i) == 'iPhone'
                        ? 'iPhone'
                        : userAgent.match(/Android/i) == 'Android'
                        ? 'Android'
                        : userAgent.match(/BlackBerry/i) == 'BlackBerry'
                        ? 'BlackBerry'
                        : null;
            }

            return this.deviceType;
        };

        this.getDevicePlatform = function () {
            if ($window.device && $window.device.platform) {
                return $window.device.platform;
            }

            return '';
        };

        this.getDeviceVersion = function () {
            if ($window.device && $window.device.version) {
                return $window.device.version;
            }

            return '';
        };

        this.getDeviceModel = function () {
            if ($window.device && $window.device.model) {
                return $window.device.model;
            }

            return '';
        };

        this.isIPhoneX = function () {
            return this.getDeviceModel() === 'iPhone10,3' || this.getDeviceModel() === 'iPhone10,6';
        };

        this.getIOSOffsetClass = function () {
            if (this.getDeviceType() === 'iPhone') {
                if (this.hasHomeButton()) {
                    return 'ios-offset-20';
                } else {
                    //no margin for iPhone X* devices
                    //return empty string so no class is set
                    return '';
                }
            } else if (this.getDeviceType() === 'iPad') {
                if (!this.hasHomeButton()) {
                    return 'ios-offset-24';
                } else {
                    return 'ios-offset-20';
                }
            }
            return '';
        };

        this.hasHomeButton = function () {
            if (this.isMobileRedirectByPass()) {
                return false;
            }

            //for ios use only - checkes to see if device has a physical home button
            var match = /\d+/;
            var isIPad = this.getDeviceType() === 'iPad';
            var isIPhone = this.getDeviceType() === 'iPhone';
            var modelGen = this.getDeviceModel().match(match)[0];
            //ipad
            if (isIPad) {
                if (modelGen >= 8) {
                    return false;
                }
                return true;
            }
            //iPhone
            if (isIPhone) {
                if (modelGen >= 11 || this.isIPhoneX()) {
                    return false;
                }
                return true;
            }
            return false;
        };

        this.hasNotificationAPI = function () {
            return !!$window.Notification;
        };

        this.requestNotificationAPIPermission = function () {
            if (
                this.hasNotificationAPI() &&
                // no need to ask on permissions in case user manually blocked it
                $window.Notification.permission !== 'denied' &&
                // no need to ask on permissions if it is already allowed
                $window.Notification.permission !== 'granted'
            ) {
                // Request permission to show desktop notifications
                $window.Notification.requestPermission().then(function (result) {
                    logger.log('requestNotificationAPIPermission', 'Notification.requestPermission result: ' + result);
                });
            }
        };

        this.hasNotificationAPIPermission = function () {
            return this.hasNotificationAPI() === true && $window.Notification.permission === 'granted';
        };

        this.tryRequestDesktopNotificationPermission = function () {
            if (this.isMobile() === false) {
                this.requestNotificationAPIPermission();
            }
        };

        //Minimum Chrome Version Supported
        this.minChromeVersion = 65;

        this.isElectronVersionSupported = function () {
            let electronChromeVersion;
            try {
                var raw = $window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                electronChromeVersion = parseInt(raw[2]);
            } catch (e) {
                logger.error('isElectronVersionSupported', 'failed to get chrome version', e);
            }

            if (electronChromeVersion !== undefined && electronChromeVersion >= this.minChromeVersion) {
                return true;
            }

            return false;
        };

        this.isBrowserVersionSupported = function () {
            if (this.isMobileRedirectByPass()) {
                return true;
            }

            if (this.isElectron()) {
                return this.isElectronVersionSupported();
            }

            if (this.isChrome()) {
                return this.getChromeVersion() >= this.minChromeVersion ? true : false;
            }

            return true;
        };

        this.isUniteWeb = function () {
            if (this.isUniteWebField === undefined) {
                this.isUniteWebField = !this.isElectron() && !!$window.opener;
            }

            return this.isUniteWebField;
        };

        this.isUniteAgent = function () {
            const userAgent = $window.navigator.userAgent;
            const uniteAgents = ['-unite', 'Unite/', 'uc-client/'];

            return uniteAgents.some(agent => userAgent.indexOf(agent) > -1);
        };

        this.isUniteApplication = function () {
            if (this.isUniteApp === undefined) {
                this.isUniteApp = this.isElectron() && this.isUniteAgent();
            }
            return this.isUniteApp;
        };

        this.isNotAuthenticatedUniteApplication = function () {
            return this.isUniteApplication() && !(self.uniteSupportedFeatures.isAuthenticated ?? true);
        };

        this.isLoginFormVisible = function () {
            return !this.isUniteApplication() || this.isNotAuthenticatedUniteApplication();
        };

        // extracted browser.service.ts as isUniteRoomsApplication$
        this.isVideoRoomApplication = function () {
            if (this.isUniteRoomsApp === undefined) {
                var userAgent = $window.navigator.userAgent;
                // video-room-display is legacy user agent, it can be removed before Unite rooms GA
                var hasAgentMatch =
                    userAgent.indexOf('rooms-display/') > -1 || userAgent.indexOf('video-room-display') > -1;
                this.isUniteRoomsApp = this.isElectron() && hasAgentMatch;
            }
            return this.isUniteRoomsApp;
        };

        // extracted browser.helper.ts
        this.isElectron = function () {
            return this.isElectronApp;
        };

        // here is a BUG: modern edge also pass this check
        this.isChrome = function () {
            let isChromium = $window.chrome, // headless chrome has no chrome object
                isHeadlessChrome = this.isHeadlessChrome(),
                vendorName = $window.navigator.vendor,
                isOpera = this.isOperaBrowser(),
                isEdgeLegacy = this.isEdgeBrowser(),
                isMobile = this.isMobile();

            if (
                (isChromium || isHeadlessChrome) &&
                vendorName === 'Google Inc.' &&
                !isOpera &&
                !isEdgeLegacy &&
                !isMobile
            ) {
                return true;
            } else {
                return false;
            }
        };

        this.isHeadlessChrome = function () {
            const userAgent = $window.navigator.userAgent.toLowerCase();
            return userAgent.indexOf('headlesschrome') > -1;
        };

        this.isAndroid = function () {
            return this.getDeviceType() === 'Android';
        };

        this.isSupportedClient = function () {
            return this.isChrome() || this.isElectron() || this.isVideoRoomApplication();
        };

        this.isStartedFromWebinarDashboard = function () {
            if ($window.document.referrer) {
                try {
                    const referrerUrl = new URL($window.document.referrer);
                    return referrerUrl.host === 'dashboard.' + this.getLocationHost();
                } catch (e) {
                    return false;
                }
            }
            return false;
        };

        this.getElectronVersion = function () {
            if (!this.isElectron()) return;
            let electronVersion = $window.navigator.userAgent.match(/Electron\/([\d\.]+\d+)/)[1];
            let majorVersion = Number(electronVersion.split('.')[0]);
            return majorVersion;
        };

        this.getChromeVersion = function () {
            if (!this.isChrome() && !this.isAndroid()) {
                return false;
            }
            var raw = $window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
            return raw ? parseInt(raw[2]) : false;
        };

        this.getSafariVersion = function () {
            if (!this.isSafari()) {
                return false;
            }
            var raw = $window.navigator.userAgent.match(/Version\/([0-9]+)\./);
            return raw ? parseInt(raw[1]) : false;
        };

        this.isChromeOSXCatalina = function () {
            return this.isChrome() && this.isOSXCatalina();
        };

        this.isOSXCatalina = function () {
            return /Mac OS X (10[_\.]15)/.test($window.navigator.userAgent);
        };

        // extracted browser.helper.ts
        this.isFirefox = function () {
            var userAgent = $window.navigator.userAgent;

            if (userAgent.indexOf('Firefox') !== -1) {
                return true;
            } else {
                return false;
            }
        };

        this.getFirefoxVersion = function () {
            if (!this.isFirefox()) {
                return false;
            }
            var raw = $window.navigator.userAgent.split('Firefox/');
            return parseInt(raw[1]);
        };

        // extracted browser.helper.ts
        // It is a check for Edge Legacy browser.
        // Modern EDGE has a user agent 'edg'
        this.isEdgeBrowser = function () {
            //this will query for 'edge' (case insensitive) in navigator.useragent string.
            //so far only Microsoft Edge has 'Edge/' + numerical value as part of its useragent string
            //using that to decide if browser is Edge
            //Make sure that for the "New Edge" based on Chromium it does not match, and returns false.
            return $window.navigator.userAgent.match(/edge\/\d+/i) !== null;
        };

        this.isOperaBrowser = function () {
            return $window.navigator.userAgent.indexOf('OPR') > -1;
        };

        this.isIE = function () {
            var userAgent = $window.navigator.userAgent;

            if (userAgent.indexOf('MSIE') > 0 || userAgent.indexOf('Trident') > 0) {
                return true;
            } else {
                return false;
            }
        };

        // extracted browser.helper.ts
        this.isSafari = function () {
            var ua = $window.navigator.userAgent.toLowerCase();

            if (ua.indexOf('safari') != -1) {
                if (ua.indexOf('chrome') > -1) {
                    return false; //chrome
                } else {
                    return true;
                }
            }

            return false;
        };

        // extracted browser.helper.ts as isLegacyMobile
        this.isMobile = function () {
            return $window.cordova !== undefined;
        };

        this.isTablet = function () {
            return $window.isTablet;
        };

        this.generateGUID = function (attendantLoginId) {
            var id = attendantLoginId || 0;
            var time = new Date().getTime();

            return id + '_' + time;
        };

        //TODO: Create mobileService for functions like these?
        this.getMobileMicAuthorization = function () {
            var deferred = $q.defer();

            logger.log('getMobileMicAuthorization', 'Retrieving mobile mic authorization');

            try {
                $window.cordova.plugins.diagnostic.isMicrophoneAuthorized(
                    function (authorized) {
                        logger.log(
                            'getMobileMicAuthorization',
                            'App is currently ' + (authorized ? 'authorized' : 'denied') + ' access to the microphone'
                        );

                        if (authorized) {
                            deferred.resolve(true);
                        } else {
                            $window.cordova.plugins.diagnostic.getMicrophoneAuthorizationStatus(
                                function (status) {
                                    logger.log('getMobileMicAuthorization', 'Microphone status is: ' + status);

                                    if (status === $window.cordova.plugins.diagnostic.permissionStatus.GRANTED) {
                                        deferred.resolve(true);
                                    } else if (
                                        self.getDevicePlatform() !== 'iOS' ||
                                        status === $window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED
                                    ) {
                                        $window.cordova.plugins.diagnostic.requestMicrophoneAuthorization(
                                            function (micAuthorized) {
                                                if (
                                                    micAuthorized ===
                                                    $window.cordova.plugins.diagnostic.permissionStatus.GRANTED
                                                ) {
                                                    deferred.resolve(true);
                                                } else {
                                                    deferred.reject(
                                                        'Microphone use has not been authorized: ' + micAuthorized
                                                    );
                                                }
                                            },
                                            function (error) {
                                                deferred.reject(
                                                    'The following error occurred requesting microphone authorization: ' +
                                                        error
                                                );
                                            }
                                        );
                                    } else {
                                        deferred.reject(
                                            'Microphone use is not authorized: ' +
                                                status +
                                                ', platform: ' +
                                                self.getDevicePlatform()
                                        );
                                    }
                                },
                                function (error) {
                                    deferred.reject(
                                        'The following error occurred requesting microphone authorization status: ' +
                                            error
                                    );
                                }
                            );
                        }
                    },
                    function (error) {
                        deferred.reject(
                            'The following error occurred while checking if the microphone is authorized: ' + error
                        );
                    }
                );
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        this.getMobileCameraAuthorization = function () {
            var deferred = $q.defer();

            logger.log('getMobileCameraAuthorization', 'Retrieving mobile cam authorization');

            try {
                $window.cordova.plugins.diagnostic.isCameraAuthorized(
                    function (authorized) {
                        logger.log(
                            'getMobileCameraAuthorization',
                            'App is currently ' + (authorized ? 'authorized' : 'denied') + ' access to the camera'
                        );

                        if (authorized) {
                            deferred.resolve(true);
                        } else {
                            $window.cordova.plugins.diagnostic.getCameraAuthorizationStatus(
                                function (status) {
                                    logger.log('getMobileCameraAuthorization', 'Camera status is: ' + status);

                                    if (status === $window.cordova.plugins.diagnostic.permissionStatus.GRANTED) {
                                        deferred.resolve(true);
                                    } else if (
                                        self.getDevicePlatform() !== 'iOS' ||
                                        status === $window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED
                                    ) {
                                        $window.cordova.plugins.diagnostic.requestCameraAuthorization(
                                            function (status) {
                                                if (
                                                    status ===
                                                    $window.cordova.plugins.diagnostic.permissionStatus.GRANTED
                                                ) {
                                                    deferred.resolve(true);
                                                } else {
                                                    deferred.reject('Camera use has not been authorized: ' + status);
                                                }
                                            },
                                            function (error) {
                                                deferred.reject(
                                                    'The following error occurred requesting camera authorization: ' +
                                                        error
                                                );
                                            }
                                        );
                                    } else {
                                        deferred.reject(
                                            'Camera use is not authorized: ' +
                                                status +
                                                ', platform: ' +
                                                self.getDevicePlatform()
                                        );
                                    }
                                },
                                function (error) {
                                    deferred.reject(
                                        'The following error occurred requesting camera authorization status: ' + error
                                    );
                                }
                            );
                        }
                    },
                    function (error) {
                        deferred.reject(
                            'The following error occurred while checking if the camera is authorized: ' + error
                        );
                    }
                );
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        this.setIsPageUnloading = function (newIsPageUnloading) {
            isPageUnloading = newIsPageUnloading;
            meetingStateService.pageIsUnloading = newIsPageUnloading;
        };

        this.getIsPageUnloading = function () {
            return isPageUnloading;
        };

        this.setIsMeetingEnding = function (meetingIsEnding) {
            meetingStateService.meetingIsEnding = meetingIsEnding;

            if (meetingIsEnding === true) {
                $rootScope.$broadcast('disable-snap-engage-live-support');
            }
        };

        this.getIsMeetingEnding = function () {
            return this.meetingIsEnding;
        };

        this.isFullScreen = function () {
            var docElement = $window.document || {};
            var fullScreenElement =
                docElement.fullscreenElement ||
                docElement.webkitFullscreenElement ||
                docElement.mozFullScreenElement ||
                docElement.msFullscreenElement;

            return fullScreenElement ? true : false;
        };

        //For HD ScreenShare
        this.getAddMemberKeyFrameDelay = function () {
            //This number matches a config value from node server
            var addMemberKeyFrameDelay = 5 * 1000;

            //2 second delay for the time it takes to receive/render keyframe
            addMemberKeyFrameDelay += 2000;

            return addMemberKeyFrameDelay;
        };

        this.getMobileAppPackageName = function () {
            return this.mobileAppPackageName || '';
        };

        this.lockOrientation = function (newOrientation) {
            try {
                if ($window.screen.lockOrientation) {
                    $window.screen.lockOrientation(newOrientation);
                } else if ($window.screen.orientation.lock) {
                    $window.screen.orientation.lock(newOrientation);
                }
            } catch (e) {
                //Fail silently
            }
        };

        this.unlockOrientation = function () {
            try {
                if ($window.screen.lockOrientation) {
                    $window.screen.unlock();
                } else if ($window.screen.orientation.unlock) {
                    $window.screen.orientation.unlock();
                }
            } catch (e) {
                //Fail silently
            }
        };

        this.getUrlWithChimeQueryString = function () {
            if (this.getQueryParameter('waitingForMeeting') !== '') {
                return $window.location.href;
            }
            var queryStringPrefix;
            var queryString = 'waitingForMeeting=true';
            var regex = new RegExp('[\\?&].*=([^&#]*)'),
                results = regex.exec($window.location.search);
            queryStringPrefix = results == null ? '?' : '&';

            return $window.location.href + queryStringPrefix + queryString;
        };

        this.setUniteSupportedFeatures = function (features) {
            self.uniteSupportedFeatures = features;
        };

        this.setSystemInfo = function (info) {
            self.systemInfo.osRelease = info.os;
            self.systemInfo.cpuModel = info.cpuModel;
            self.systemInfo.cpuUsage = info.cpuUsage;
            self.systemInfo.totalMemory = info.totalMemory;
        };

        this.getSystemInfo = function () {
            return self.systemInfo;
        };

        this.isUniteSupportFeature = function (feature) {
            feature = (feature + '').toLowerCase();
            for (var prop in self.uniteSupportedFeatures) {
                if (self.uniteSupportedFeatures.hasOwnProperty(prop) && feature === (prop + '').toLowerCase()) {
                    return self.uniteSupportedFeatures[prop] === true;
                }
            }

            return false;
        };

        this.disableUniteSupportedFeature = function (feature) {
            var result = false;
            feature = (feature + '').toLowerCase();
            for (var prop in self.uniteSupportedFeatures) {
                if (self.uniteSupportedFeatures.hasOwnProperty(prop) && feature === (prop + '').toLowerCase()) {
                    self.uniteSupportedFeatures[prop] = false;
                    result = true;
                }
            }

            if (!result) {
                logger.log(
                    'disableUniteSupportedFeature',
                    "Can not disable unite supported feature '" + feature + "'."
                );
            }
        };

        this.notNullOrUndefined = function (val) {
            return val !== null && val !== undefined;
        };

        this.encodeHtml = function (value) {
            return $('<div/>').text(value).html();
        };

        this.decodeHtml = function (value) {
            return $('<div/>').html(value).text();
        };

        this.sanitizeHtml = function (html) {
            if (typeof html !== 'string') {
                return '';
            }

            return html
                .replace(/&/g, '&amp;')
                .replace(/>/g, '&gt;')
                .replace(/</g, '&lt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&apos;');
        };

        // Just an helper to generate random usernames
        this.randomString = function (len, charSet) {
            charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var randomString = '';
            for (var i = 0; i < len; i++) {
                var randomPoz = Math.floor(Math.random() * charSet.length);
                randomString += charSet.substring(randomPoz, randomPoz + 1);
            }
            return randomString;
        };

        this.hasScrollBar = function (selectors) {
            try {
                var el = document.querySelectorAll(selectors);
                if (el && el[0]) {
                    var scrollHeight = el[0].scrollHeight;
                    var windowHeight = el[0].offsetHeight;
                    return scrollHeight > windowHeight;
                }
            } catch (e) {}

            return false;
        };

        // extracted to attendee.helper.ts
        this.getInitialsFromName = function (name) {
            var initials = '';

            if (name) {
                var initialsParts = name.split(' ');
                var firstName = initialsParts[0];
                var lastName = initialsParts[1];

                if (firstName) {
                    initials += firstName.charAt(0);
                }

                if (lastName) {
                    initials += lastName.charAt(0);
                }
            }

            return initials;
        };

        // extracted utils.helper.ts
        this.isDefaultAvatarUrl = function (url) {
            if (url) {
                //Example url: https://www.anymeeting.com/AccountManager/images/default-avatar-40-im.png
                return url.indexOf('AccountManager') > -1 && url.indexOf('default-avatar') > -1;
            }

            return false;
        };

        // extracted to attendee.helper.ts as getAttendantAvatarColor
        this.convertContactDataToColorClass = function (id, displayName) {
            var bgColor = ['pink', 'orange', 'yellow', 'green', 'cyan', 'blue', 'purple', 'darkorange'];

            if (id === null || id === undefined || displayName === null || displayName === undefined) {
                return 'blue'; //for default color, return consistent color (as opposed to randomized each time)
            }

            var concatStr = displayName + id;
            var pre =
                Math.abs(
                    concatStr.split('').reduce(function (a, b) {
                        a = (a << 5) - a + b.charCodeAt(0);
                        return a & a;
                    }, 0)
                ) % 8;
            return bgColor[pre];
        };

        // extracted browser.service.ts
        this.getEnvironment = function () {
            var locationHost = this.getLocationHost().toLowerCase();

            if (
                locationHost.indexOf('anymeeting.com') > -1 ||
                locationHost.indexOf('gomeet.com') > -1 ||
                locationHost.indexOf('meetuniverge.blue') > -1 ||
                this.getQueryParameter('isProd') === 'true'
            ) {
                return 'prod';
            } else if (locationHost.indexOf('-staging.com') !== -1) {
                return 'staging';
            } else {
                return 'qa';
            }
        };

        this.getMeetingTypeByDomain = function () {
            var domain = $location.host().toLowerCase();

            return domain.indexOf('webinar.') === 0 ? 'webinar' : 'meeting';
        };

        this.getAPIUrl = function () {
            var host = this.getLocationHost();
            if (host === 'localhost' || host.indexOf('-local.com') !== -1) {
                return config.api.url + '/api';
            }
            var prot = this.getLocationProtocol();
            var result = prot + '://' + 'api.' + host + '/api';
            return result;
        };

        this.b64EncodeUnicode = function (str) {
            return btoa(
                encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1);
                })
            );
        };

        this.isElectronOnMac = function () {
            return this.isMac() && this.isElectron();
        };

        this.getAppInsightsConfig = function () {
            if (this.getLocationHost() === 'localhost' || this.getLocationHost().indexOf('-local.com') !== -1) {
                return config.appInsights.qa;
            }

            if (this.getLocationHost().indexOf('-qa.com') !== -1) {
                return config.appInsights.qa;
            }

            if (this.getLocationHost().indexOf('-staging.com') !== -1) {
                return config.appInsights.staging;
            }

            return config.appInsights.prod;
        };

        this.shouldSidebarCollapse = function () {
            return this.getQueryParameter('keepSidebarOpen') !== 'true' && $window.$(window).width() < 900;
        };

        this.setMinimizedSideBarClickedState = function (newVal) {
            this.minimizedSideBarClickedOpen = newVal;
        };

        this.getMinimizedSideBarClickedState = function () {
            return this.minimizedSideBarClickedOpen;
        };

        this.setSideBarClickedState = function (newVal) {
            this.sideBarClickedOpen = newVal;
        };

        this.getSideBarClickedState = function () {
            return this.sideBarClickedOpen;
        };

        this.isLeftSidebarVisible = function () {
            var sideBarElement = $window.angular.element('#sidebar-left');
            if (sideBarElement && sideBarElement[0] && sideBarElement[0].className) {
                return sideBarElement[0].className.indexOf('toggled') >= 0;
            } else {
                return false;
            }
        };

        this.isDefaultMutedStateNotificationVisible = function () {
            if (this.getIsRedesign()) {
                return $window.$('#toggle-mic').find('.muted-mic-popover-content').is(':visible');
            } else {
                return $window.$('#toggle-mic').siblings('.popover').find('.mute-popover-title').is(':visible');
            }
        };

        // extracted browser.helper.ts
        this.hasSupportForE2EEModern = function () {
            return !!$window.RTCRtpSender.prototype.createEncodedStreams;
        };

        // extracted browser.helper.ts
        this.hasSupportForE2EELegacy = function () {
            return !!$window.RTCRtpSender.prototype.createEncodedVideoStreams;
        };

        // extracted browser.helper.ts
        this.hasSupportForE2EE = function () {
            // E2EE is not yet supported for Camaro and VideoRooms
            if (this.isElectron() && !this.isUniteApplication()) {
                return false;
            }

            return (
                this.getVDIRef().isE2EESupported && (this.hasSupportForE2EELegacy() || this.hasSupportForE2EEModern())
            );
        };

        this.hasScreenRecordingPermissions = function () {
            return new Promise(resolve => {
                try {
                    if (this.isElectron() && this.isMac()) {
                        if (this.isUniteApplication()) {
                            resolve(
                                Promise.resolve(
                                    // We wrap this call to promise because it can return both:
                                    // 1. Promise from new Unite versions
                                    // 2. String from older Unite versions
                                    $window.preloadedApi.systemPreferences.getMediaAccessStatus('screen')
                                ).then(status => status === 'granted')
                            );
                            return;
                        } else {
                            resolve($window.preloadedApi.hasScreenRecordingPermissions());
                            return;
                        }
                    } else {
                        resolve(true);
                        return;
                    }
                } catch (error) {
                    logger.error('hasScreenRecordingPermissions', 'Error', error);
                    resolve(false);
                    return;
                }
            });
        };

        this.setVDIRef = function (value) {
            self.vdiRef = value;
        };

        this.getVDIRef = function () {
            return self.vdiRef;
        };

        // Dynamically create a video element and attach it to DOM
        this.createPreviewVideoElement = function () {
            const videoOnlyContainer = $window.$('#video-only-container')[0];
            if (videoOnlyContainer) {
                const el = document.createElement('video');
                el.setAttribute('id', 'video-preview');
                el.setAttribute('autoplay', 'autoplay');
                el.setAttribute('muted', 'muted');

                videoOnlyContainer.appendChild(el);
            }
        };

        // Remove the video element from DOM
        this.removePreviewVideoElement = function () {
            const videoPreviewElement = $window.$('#video-only-container > #video-preview')[0];
            if (videoPreviewElement) {
                self.vdiRef.destroyVideoElement(videoPreviewElement);
                videoPreviewElement.remove();
            }
        };

        this.onScopeDestroyed = () => {
            subscriptionService.endSubscription(self.rootSubscription);
        };

        //#region AngularSubscriptions

        const subscribeToState = () => {
            self.rootSubscription.add(
                helperStateService.mobileHost$.subscribe(next => {
                    self.mobileHost = next;
                })
            );

            self.rootSubscription.add(
                helperStateService.isElectron$.subscribe(next => {
                    self.isElectronApp = next;
                })
            );

            self.rootSubscription.add(
                helperStateService.useRedesign$.subscribe(next => {
                    self.useRedesign = next;
                })
            );

            self.rootSubscription.add(
                helperStateService.browserHasWebRTC$.subscribe(next => {
                    self._browserHasWebRTC = next;
                })
            );

            self.rootSubscription.add(
                meetingStateService.meetingIsEnding$.subscribe(next => {
                    self.meetingIsEnding = next;
                })
            );
        };

        const subscribeToCalculatedProperties = () => {
            self.rootSubscription.add(
                browserUpgradedService.locationHost$.subscribe(next => {
                    cachedLocationHost = next;
                })
            );
        };

        const initSubscriptions = () => {
            self.rootSubscription = subscriptionService.createSubscription();
            subscribeToState();
            subscribeToCalculatedProperties();
        };

        this.isEqual = function (obj1, obj2) {
            if (obj1 && obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) {
                    return false;
                }
                for (var key in obj1) {
                    if (obj1[key] !== obj2[key]) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        };

        this.isObjectEqual = function (object1, object2) {
            // save objects that have been visited in seen, to detect circular references
            let seen = new Set();
            this.compareNestedObj = function (obj1, obj2) {
                let same = true;
                if (obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object') {
                    seen.add(obj1);
                    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
                        return false;
                    }
                    for (var key in obj1) {
                        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object' && !seen.has(obj1[key])) {
                            if (!this.compareNestedObj(obj1[key], obj2[key])) {
                                return false;
                            }
                        } else if (obj1[key] !== obj2[key]) {
                            return false;
                        }
                    }
                } else if (obj1 !== obj2) {
                    same = false;
                }
                return same;
            };
            return this.compareNestedObj(object1, object2);
        };

        this.removeDeprecatedIceServers = function (iceServers) {
            iceServers.forEach(function (iceServer) {
                if (iceServer.url && !iceServer.urls) {
                    iceServer.urls = iceServer.url;
                }
                if (iceServer.url) {
                    delete iceServer.url;
                }
            });
        };

        this.isMouseEventInElement = function (event, element) {
            const rect = element.getBoundingClientRect();
            const x = event.clientX;
            if (x < rect.left || x >= rect.right) {
                return false;
            }
            const y = event.clientY;
            if (y < rect.top || y >= rect.bottom) {
                return false;
            }
            return true;
        };

        this.isMobileRedirectByPass = function () {
            if (self.getQueryParameter('disableMobileRedirect') === 'true') {
                return true;
            }

            return false;
        };

        initSubscriptions();
        //#endregion
    }
]);
